module.exports = __webpack_public_path__ + "static/media/scrubblitz-3.edcb7b1d.jpg";